const styles = theme => ({
  iconButton: {
    height: 40,
    width: 40,
    fontSize: 22,
  }
});

export default styles;